
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The name of the advertisement product for displaying to the user.`}</p>
    <p>{`This field is for display purposes only and should not be used to determine any features of an ad.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;